import { CANCEL_DEALS_UPDATES, UPDATE_DEAL } from './ActionTypes';
import { fetchDealData } from './DealsActions';
import { getDealTablePagination, getIsDefaultSort, getDealTableSort } from '../selectors/dealsSelectors';
import { convertPaginationStateForApi, convertSortStateForApi } from '../utils/deals';
export function updateDealProperty({
  dealId,
  property,
  value
}) {
  return dispatch => dispatch({
    type: UPDATE_DEAL,
    payload: {
      dealId,
      property,
      value
    }
  });
}
export function cancelDealsUpdates(ownerId) {
  return (dispatch, getState) => {
    const state = getState();
    const pagination = getDealTablePagination(state);
    const sort = getDealTableSort(state);
    const isDefaultSort = getIsDefaultSort(state);
    dispatch({
      type: CANCEL_DEALS_UPDATES
    });
    return dispatch(fetchDealData(ownerId, Object.assign({}, convertPaginationStateForApi(pagination), {
      sorts: convertSortStateForApi(sort, isDefaultSort)
    })));
  };
}